import request from './request'
//登录
export function apiLogin(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/admin/login',
  })
  return request(config)
}

//注册
export function apiAdd(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/admin/add',
  })
  return request(config)
}

//员工退出
export function apiLogout(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/admin/logout',
  })
  return request(config)
}
